import { render, staticRenderFns } from "./Reroute.vue?vue&type=template&id=cd1b08e4&"
import script from "./Reroute.vue?vue&type=script&lang=js&"
export * from "./Reroute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports